
<template>
    <div class="auth-card">
      <h2 class="k6-green-text text-center" style="font-weight: 700;">{{ $t("pages.login.login") }}</h2>
      <div style="display: flex; justify-content: center;">
        <button 
          name="GoogleSigninButton"
          @click="loginSsoGoogle"
          class="google-login-btn"
        >
          <img 
            src="../../assets/google.png" 
            class="google-icon"
          />
          {{ $t("pages.login.google") }}
        </button>
      </div>
      
      <form class="form-horizontal" style="padding: 10px;" @submit.prevent="submitData">
        <div class="form-group">
          <label for="inputEmail3" class="col-sm-12">{{$t('pages.login.username')}}</label>
          <div class="col-sm-12">
            <input type="text" :value="identifier" @input="updateLoginIdentifier" class="form-control" id="inputEmail3" autofocus>
          </div>
        </div>
        <div class="form-group">
          <label for="inputPassword3" class="col-sm-12">{{$t('pages.login.password')}}</label>
          <div class="col-sm-12">
            <input type="password" @input="updateLoginPassword" class="form-control" id="inputPassword3">
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div>
            <div class="checkbox" style="padding-top: 0px;">
              <label>
                <input type="checkbox" id="remeber" :value="rememberMe" @input="updateLoginRememberMe" v-model="rememberMe">{{$t('pages.login.remeberMe')}}
              </label>
            </div>
            <br>              
          </div>
          <div class="text-right">
            <a href="#" class="k6-green-text" @click.prevent="updateLoginResetForm">{{$t('pages.login.forgotPassword')}}</a>
          </div>
        </div>
        
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; gap: 20px">
          <button type="submit" class="k6-primary-btn" @click.prevent="submitData">{{$t('pages.login.login')}}</button>
          <div>
            <span>
              {{ $t("pages.home.helloRegister") }}
              <a class="k6-green-text" @click.prevent="toRegister">{{ $t("pages.register.register") }}</a>
            </span>
          </div>
        </div>
        
      </form>
    </div>

</template>

<script>
  import router from './../../router/router'
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: ['loginSsoGoogle', 'switchAuthView'],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters({
        pictureBaseURL: 'pictureBaseURL',
        googleSignInParams: 'googleSignInParams',
        jeAdmin: 'hasAdminRole'
      }),
      ...mapState({
        identifier: state => state.login.identifier,
        password: state => state.login.password,
        rememberMe: state => state.login.rememberMe,
        status: state => state.login.status,
        submited: state => state.login.submited
      })
    },
    methods: {
      updateLoginResetForm () {
        window.jQuery('#resetPasswordModal').modal('toggle')
      },
      updateLoginIdentifier (e) {
        this.$store.commit('updateLoginIdentifier', e.target.value)
      },
      updateLoginPassword (e) {
        this.$store.commit('updateLoginPassword', e.target.value)
      },
      updateLoginRememberMe (e) {
        this.$store.commit('updateLoginRememberMe', e.target.value)
      },
      submitData (uporIme, pass) {
        this.$store.dispatch('login', {
          identifier: this.identifier,
          password: this.password,
          rememberMe: this.rememberMe
        }, uporIme, pass).then(() => {
          router.push({name: this.jeAdmin ? 'adminGroups' : 'groupList'})
          this.$store.dispatch('updateLanguage', localStorage.getItem('language')).then(() => {
          }).catch(() => {
            console.log('Error in login!')
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      toRegister () {
        this.switchAuthView('register')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?31a4643d